import { styled, theme } from "@theme/stitches.config"
import { Container } from "@components/styles"
// eslint-disable-next-line import/no-unresolved
import { Swiper } from "swiper/react"

export const ImageSliderWrapper = styled("div", {
    backgroundColor: theme.colors.N900
})

export const InnerWrapper = styled(Container, {
    pt: 90,
    "@mdDown": {
        pt: 60
    }
})

export const SocialsWrapper = styled("div", {
    display: "flex",
    alignItems: "center",
    mx: -10,
    mt: 70,
    "@mdDown": {
        mt: 50
    }
})

export const Social = styled("a", {
    px: 10
})

export const StyledSwiper = styled(Swiper, {
    mt: 65,
    "& .swiper-wrapper": {
        transitionTimingFunction: "linear !important"
    },
    "& .swiper-slide": {
        width: "300px !important",
        minWidth: 300,
        "@mdDown": {
            width: "200px !important",
            minWidth: 200
        }
    },
    "& img": {
        display: "block",
        width: 300,
        height: 300,
        minWidth: 300,
        minHeight: 300,
        marginLeft: "auto",
        marginRight: "auto",
        objectFit: "cover",
        borderRadius: 4,
        "@mdDown": {
            width: 200,
            height: 200,
            minWidth: 200,
            minHeight: 200
        }
    }
})
